import React, { useCallback, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { Modal } from "@pl/paylican-ui-kit";
import { useKeycloakContext } from "@wf/keycloak-axios-provider";

import ErrorModalView from "./ErrorModalView";
import { checkModalVisibility, getModalByName } from "../../../redux/modal/selectors";
import { hideModal } from "../../../redux/modal/actions";
import modalNames from "../../../constants/modalNames";

import styles from "./ErrorModal.module.scss";
import { closeModalByESC } from "../../../utils/closeModalByESC";

const ErrorModal = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const modalData = useSelector(store => getModalByName(store, modalNames.ERROR_MODAL));
  const isModalVisible = useSelector(store => checkModalVisibility(store, modalNames.ERROR_MODAL));
  const keycloakContext = useKeycloakContext();

  const handleModalClose = useCallback(() => {
    let redirectUri = modalData?.errors
      ?.map(err => err?.data?.redirectAfterCloseUrl)
      ?.find(redirectUrl => !!redirectUrl);

    dispatch(hideModal(modalNames.ERROR_MODAL));

    if (redirectUri) {
      keycloakContext.logout({ redirectUri });
    }
  }, [dispatch, modalData, keycloakContext]);

  const errors = modalData?.errors ?? [];

  useEffect(() => {
    closeModalByESC(isModalVisible, handleModalClose);
  }, [isModalVisible, handleModalClose]);

  return (
    <Modal
      show={isModalVisible}
      handleClose={handleModalClose}
      title={<div className={styles.title}>{t("ERROR")}</div>}
    >
      <ErrorModalView errors={errors} />
    </Modal>
  );
};

export default ErrorModal;
